"use strict";
/**
 * @file Created on 23.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var NotificationConverter_1 = require("./conversions/NotificationConverter");

var NotificationConverterImpl_1 = require("./conversions/NotificationConverterImpl");

var NChangedGroupOfSitesConverterImpl_1 = require("./documents/conversions/NChangedGroupOfSitesConverterImpl");

var NChangedGroupOfSitesDTOConverterImpl_1 = require("./documents/conversions/NChangedGroupOfSitesDTOConverterImpl");

var NChangedProdThresholdConverterImpl_1 = require("./documents/conversions/NChangedProdThresholdConverterImpl");

var NChangedProdThresholdDTOConverterImpl_1 = require("./documents/conversions/NChangedProdThresholdDTOConverterImpl");

var NChangedProductConverterImpl_1 = require("./documents/conversions/NChangedProductConverterImpl");

var NChangedProductDTOConverterImpl_1 = require("./documents/conversions/NChangedProductDTOConverterImpl");

var NChangedWinDateConverterImpl_1 = require("./documents/conversions/NChangedWinDateConverterImpl");

var NChangedWindowDTOConverterImpl_1 = require("./documents/conversions/NChangedWindowDTOConverterImpl");

var NChangedWinPriceValidityConverterImpl_1 = require("./documents/conversions/NChangedWinPriceValidityConverterImpl");

var NChangedWinThresholdConverterImpl_1 = require("./documents/conversions/NChangedWinThresholdConverterImpl");

var NSimDummyCreatedDTOConverterImpl_1 = require("./documents/conversions/NSimDummyCreatedDTOConverterImpl");

var NSimDummyProductConverterImpl_1 = require("./documents/conversions/NSimDummyProductConverterImpl");

var NSimulationDTOConverterImpl_1 = require("./documents/conversions/NSimulationDTOConverterImpl");

var NSimulationProductDTOConverterImpl_1 = require("./documents/conversions/NSimulationProductDTOConverterImpl");

var NSimulationWindowDTOConverterImpl_1 = require("./documents/conversions/NSimulationWindowDTOConverterImpl");

var NThresholdPromoVolumeConverterImpl_1 = require("./documents/conversions/NThresholdPromoVolumeConverterImpl");

var NThresholdPromoVolumeDTOConverterImpl_1 = require("./documents/conversions/NThresholdPromoVolumeDTOConverterImpl");

var NThresholdSystemVolumeConverterImpl_1 = require("./documents/conversions/NThresholdSystemVolumeConverterImpl");

var NThresholdSystemVolumeDTOConverterImpl_1 = require("./documents/conversions/NThresholdSystemVolumeDTOConverterImpl");

var NWindowWrapperConverterImpl_1 = require("./documents/conversions/wrappers/NWindowWrapperConverterImpl");

var NotificationDocConverter_1 = require("./documents/NotificationDocConverter");
/**
 * @author Jaroslav Sevcik
 * @author Tomas Leity
 */


var NotificationsAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(NotificationsAppModule, _AppModule_1$AppModul);

  function NotificationsAppModule() {
    var _this;

    _classCallCheck(this, NotificationsAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationsAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'notificationsAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NotificationsAppModule, [{
    key: "configure",
    value: function configure() {
      this.configureConverters();
    }
  }, {
    key: "configureConverters",
    value: function configureConverters() {
      typescript_ioc_1.Container.bind(NotificationConverter_1.NotificationConverter).to(NotificationConverterImpl_1.NotificationConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NWindowWrapperConverterImpl_1.NWindowWrapperConverterImpl.QUALIFIER).to(NWindowWrapperConverterImpl_1.NWindowWrapperConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedWinThresholdConverterImpl_1.NChangedWinThresholdConverterImpl.QUALIFIER).to(NChangedWinThresholdConverterImpl_1.NChangedWinThresholdConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedWinDateConverterImpl_1.NChangedWinDateConverterImpl.QUALIFIER).to(NChangedWinDateConverterImpl_1.NChangedWinDateConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedWinPriceValidityConverterImpl_1.NChangedWinPriceValidityConverterImpl.QUALIFIER).to(NChangedWinPriceValidityConverterImpl_1.NChangedWinPriceValidityConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedProductConverterImpl_1.NChangedProductConverterImpl.QUALIFIER).to(NChangedProductConverterImpl_1.NChangedProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedProductDTOConverterImpl_1.NChangedProductDTOConverterImpl.QUALIFIER).to(NChangedProductDTOConverterImpl_1.NChangedProductDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedProdThresholdConverterImpl_1.NChangedProdThresholdConverterImpl.QUALIFIER).to(NChangedProdThresholdConverterImpl_1.NChangedProdThresholdConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedProdThresholdDTOConverterImpl_1.NChangedProdThresholdDTOConverterImpl.QUALIFIER).to(NChangedProdThresholdDTOConverterImpl_1.NChangedProdThresholdDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedGroupOfSitesConverterImpl_1.NChangedGroupOfSitesConverterImpl.QUALIFIER).to(NChangedGroupOfSitesConverterImpl_1.NChangedGroupOfSitesConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedGroupOfSitesDTOConverterImpl_1.NChangedGroupOfSitesDTOConverterImpl.QUALIFIER).to(NChangedGroupOfSitesDTOConverterImpl_1.NChangedGroupOfSitesDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NThresholdPromoVolumeConverterImpl_1.NThresholdPromoVolumeConverterImpl.QUALIFIER).to(NThresholdPromoVolumeConverterImpl_1.NThresholdPromoVolumeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NThresholdPromoVolumeDTOConverterImpl_1.NThresholdPromoVolumeDTOConverterImpl.QUALIFIER).to(NThresholdPromoVolumeDTOConverterImpl_1.NThresholdPromoVolumeDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NThresholdSystemVolumeConverterImpl_1.NThresholdSystemVolumeConverterImpl.QUALIFIER).to(NThresholdSystemVolumeConverterImpl_1.NThresholdSystemVolumeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NThresholdSystemVolumeDTOConverterImpl_1.NThresholdSystemVolumeDTOConverterImpl.QUALIFIER).to(NThresholdSystemVolumeDTOConverterImpl_1.NThresholdSystemVolumeDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NSimDummyProductConverterImpl_1.NSimDummyProductConverterImpl.QUALIFIER).to(NSimDummyProductConverterImpl_1.NSimDummyProductConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NSimDummyCreatedDTOConverterImpl_1.NSimDummyCreatedDTOConverterImpl.QUALIFIER).to(NSimDummyCreatedDTOConverterImpl_1.NSimDummyCreatedDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NSimulationDTOConverterImpl_1.NSimulationDTOConverterImpl.QUALIFIER).to(NSimulationDTOConverterImpl_1.NSimulationDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NSimulationProductDTOConverterImpl_1.NSimulationProductDTOConverterImpl.QUALIFIER).to(NSimulationProductDTOConverterImpl_1.NSimulationProductDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NSimulationWindowDTOConverterImpl_1.NSimulationWindowDTOConverterImpl.QUALIFIER).to(NSimulationWindowDTOConverterImpl_1.NSimulationWindowDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(NotificationDocConverter_1.NotificationDocConverter, NChangedWindowDTOConverterImpl_1.NChangedWindowDTOConverterImpl.QUALIFIER).to(NChangedWindowDTOConverterImpl_1.NChangedWindowDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return NotificationsAppModule;
}(AppModule_1.AppModule);

exports.NotificationsAppModule = NotificationsAppModule;